import OrgHeader from '../layouts/Header/Header.vue';

export default {
  components: {
    OrgHeader,
  },
  props: {},
  data() {
    return {}
  },
  created() {},
  methods: {},
}